import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigurationService } from '../../services/configuration.service';
import { Feedback } from '../../models/lookups/feedback.model';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(protected http: HttpClient,
    protected configurations: ConfigurationService) {
  }

  save(feedback: Feedback) {
    return this.http.post(this.configurations.apiAddress + "/api/Feedback/save", feedback);
  }

  search(searchText: string) {
    let myParams = new HttpParams()
      .set('searchText', searchText == undefined ? "" : searchText)
    return this.http.get(this.configurations.apiAddress + '/api/Feedback/search', { params: myParams });
  }

  delete(id: number) {
    return this.http.delete(this.configurations.apiAddress + '/api/Feedback/delete/' + id);
  }

  getById(id: number) {
    return this.http.get(this.configurations.apiAddress + '/api/Feedback/getById/' + id);
  }

  getAll() {
    return this.http.get(this.configurations.apiAddress + '/api/Feedback/getAll/');
  }
}
